import type { Order } from '~api/tos';

import { Card, ListLayout } from '@ingrid/luterkort-react';

import { EntityReference } from '~src/components/EntityReference/EntityReference';
import { useTranslation } from '~src/i18n/use-translation';

type Props = Pick<Order, 'id' | 'external' | 'metadata'>;

export function OrderInformation({ external, id, metadata }: Props) {
  const { t } = useTranslation();

  const ids = external?.reference_ids ?? [];

  return (
    <Card.Wrapper>
      <Card.Header>{t('transportOrders.details.orderInformation')}</Card.Header>

      <Card.Content>
        <ListLayout.Column>
          <EntityReference label={t('common.orderId')} value={id} />
          <EntityReference label={t('transportOrders.details.sessionid')} value={metadata?.session?.session_id} />
          <EntityReference label={t('transportOrders.details.masterSessionId')} value={metadata?.master_session_id} />

          {ids.length ? (
            ids.map(externalId => (
              <EntityReference
                label={t('common.externalIdSource', {
                  source: metadata?.source,
                })}
                key={externalId}
                value={externalId}
              />
            ))
          ) : (
            <EntityReference label={t('common.externalId')} />
          )}
        </ListLayout.Column>
      </Card.Content>
    </Card.Wrapper>
  );
}
